import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        listing: []
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
